var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kv-tabs-container"},[_c('div',{staticClass:"kv-tabs-scroll-area"},[_c('div',{staticClass:"kv-tabs",class:{ 'kv-tabs-grow': _vm.grow }},[_vm._t("tabs")],2)]),_vm._v(" "),_c('div',{staticClass:"kv-tab-panels-container"},[_vm._t("panels")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }